<template>
  <div v-if="currentEmploye">
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-6 col-lg-4">
          <multiselect
            v-model="selectedHeaders"
            :options="headers"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Filtrer par colonne"
            label="text"
            track-by="text"
          >
            <template slot="selection" slot-scope="{ values, isOpen }">
              <span class="multiselect__single" v-if="values.length && !isOpen"
                >{{ values.length }}
                {{ values.length > 1 ? ' Colonnes' : 'Colonne' }}
              </span>
            </template>
          </multiselect>
        </div>
        <div class="col-md-6 col-lg-8 text-md-right">
          <button
            v-if="canAdd"
            type="button"
            class="btn btn-custom-primary"
            @click="addCompetenceModal"
          >
            <i class="fas fa-plus"></i>
            Ajout de compétences
          </button>

          <button
            v-if="isSelect && canRemove"
            type="button"
            class="btn btn-danger ml-4"
            @click.prevent="deleteAllSelection"
          >
            <i class="fas fa-trash"></i>
            Supprimer
          </button>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-md-12">
          <DataTable
            :currentEmploye="currentEmploye"
            :competencableUuid="competencableUuid"
            :competencableType="competencableType"
            :canRemove="canRemove"
            :headers="selectedHeaders"
            ref="datatable"
            @onSelect="onSelectRows"
            @onRowsDelete="deleteRows"
          />
        </div>
      </div>
    </div>
    <component
      :is="currentModal"
      ref="modalCompetence"
      :currentEmploye="currentEmploye"
      :competencableUuid="competencableUuid"
      :competencableType="competencableType"
      @onSuccessSavedCompetence="successSavedCompetence"
    />
  </div>
</template>

<script>
import ModalEmploye from './Modal/ModalEmploye.vue';
import ModalFormation from './Modal/ModalFormation.vue';
import DataTable from './DataTable.vue';
import URL_C from '@/http/rh/employe-competence';

export default {
  data() {
    return {
      currentModal: ModalEmploye,
      isSelect: false,
      selectedHeaders: [],
      headers: [
        {
          text: 'Domaine de compétence',
          align: 'start',
          sortable: true,
          value: 'domaine',
        },
        {
          text: 'Compétence',
          align: 'start',
          sortable: true,
          value: 'competence',
        },
        {
          text: "Date d'ajout",
          align: 'start',
          sortable: true,
          value: 'created_at',
        },
        {
          text: 'Action',
          align: 'center',
          sortable: false,
          value: 'id',
        },
      ],
    };
  },

  components: {
    DataTable,
  },
  created() {
    this.selectedHeaders = this.headers;
  },
  watch: {
    competencableType: {
      immediate: true,
      handler(val) {
        switch (val) {
          case 'formations':
            this.currentModal = ModalFormation;
            break;
          default:
            this.currentModal = ModalEmploye;
            break;
        }
      },
    },
    selectedHeaders() {
      this.selectedHeaders =
        this.selectedHeaders.length === 0 ? this.headers : this.selectedHeaders;
    },
  },
  methods: {
    successSavedCompetence() {
      this.$emit('onRefresh');
    },
    addCompetenceModal() {
      this.$refs.modalCompetence.create();
    },
    onSelectRows(isSelect) {
      this.isSelect = isSelect;
    },
    deleteAllSelection() {
      this.deleteRows(this.$refs.datatable.idsRowsSelected);
    },
    deleteRows(ids) {
      if (ids && ids.length > 0) {
        this.showConfirmDelete().then((result) => {
          if (result.value) {
            window.axios
              .delete(URL_C.COMPETENCE, {
                params: {
                  ids: ids,
                },
              })
              .then((resp) => {
                this.showSimpleAlerte('top-end', 'success', resp.data.message);
                this.$emit('onRefresh');
              })
              .catch();
          }
        });
      }
    },
  },
  props: {
    currentEmploye: {
      require: true,
      type: Object,
    },
    competencableUuid: {
      require: false,
      type: String,
      default: null,
    },
    competencableType: {
      require: false,
      type: String,
      default: null,
    },
    canAdd: {
      require: false,
      type: Boolean,
      default: true,
    },
    canRemove: {
      require: false,
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped></style>
